import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, useFormContext } from "@programari-limit/base-react";
import MuiGrid from "@mui/material/Grid";
import GridFormField from "components/GridFormField";
import { columnesSerie } from "sharedAdvancedSearch/advancedSearchColumns";

const SerieForm = () => {
    const { data } = useFormContext();

    return (
        <MuiGrid container spacing={2} sx={{ mt: 1 }}>
            <GridFormField name="codi" disabled={data?.id != null} xs={4} />
            <GridFormField name="numeroActual" xs={4} />                    
            <GridFormField name="descripcio" xs={12} />            
            <GridFormField
                name="serie"
                xs={4}
                advancedSearchColumns={columnesSerie}
                fixedFilter={`serie is null and id ! ${data?.id}`}
            />          
            <GridFormField name="tipusFactura" xs={4} />    
            <GridFormField name="tipusFacturaRect" xs={4} />  
            <GridFormField name="activa" xs={12} />
        </MuiGrid>
    );
};

export const Serie = () => {
    const { t } = useTranslation();

    const columns = [
        {
            name: "codi",
            flex: 0.5,
        },
        {
            name: "numeroActual",
            flex: 0.75,
        },
        {
            name: "descripcio",
            flex: 2,
        },
        {
            name: "serie",
            flex: 1.25,
        },
        {
            name: "tipusFactura",
            flex: 3,
        },
        {
            name: "tipusFacturaRect",
            flex: 1,
        },
        {
            name: "activa",
            flex: 0.5,
        },
    ];

    return (
        <Grid
            title={t("series.title")}
            resourceName="serie"
            columns={columns}
            formPopupEditable
            formPopupComponent={<SerieForm />}
            formPopupTitleCreate={t("series.create")}
            formPopupTitleUpdate={t("series.update")}
        />
    );
};

export default Serie;
